import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
//borrowing styles from productMenuLayout for now
import styles from "../styles/businessAnalyticsLayout.module.css";
//various charts
import { useLocation, useNavigate } from "react-router-dom";

import AnalyticsHorizontalBarChart from "../components/analyticsHorizontalBarChart";
import AnalyticsHorizontalPinChart from "../components/analyticsHorizontalPinChart";
import AnalyticsVerticalBarChart from "../components/analyticsVerticalBarChart";
export const BusinessAnalyticsLayout = ({ children, actions }: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const analytics = useSelector((state: any) => state.businessAnalytics);
  const [followerData, setFollowerData] = useState<any>();
  const [checkinData, setCheckinData] = useState<any>();
  const [followerGainData, setFollowerGainData] = useState<any>();
  const [checkinHistory, setCheckinHistory] = useState<any>();
  const [content, setContent] = useState<any>();
  const [toggleFollowers, setToggleFollowers] = useState(false);
  const [toggleCheckins, setToggleCheckins] = useState(false);
  const [followerCount, setFollowerCount] = useState<any>();

  // NEW STATE FOR HANDLING DATA VISIBILITY
  const [dataDisplayType, setDataDisplayType] = useState<"followers" | "non" | "all">("followers");

  const { businessType, activeBusiness } = useSelector((state: any) => state.business);

  useEffect(() => {
    if (location.pathname === "/analytics/followers") {
      showFollowersOnly();
    }

    if (location.pathname === "/analytics/checkins") {
      showCheckins();
      setDataDisplayType("all");
    }
  }, [location.pathname]);

  useEffect(() => {
    fetchBusinessAnalytics();
  }, [activeBusiness]);

  const fetchBusinessAnalytics = async () => {
    await actions.get();
  };

  const showFollowersOnly = () => {
    setToggleFollowers(true);
    setToggleCheckins(false);
  };

  const showCheckins = () => {
    setToggleFollowers(true);
    setToggleCheckins(true);
  };

  //format the analytics into objects suitable for the charts
  //also set the followerData and checkinData(for venues)
  let formattedAnalytics = [] as any;

  //format titles from camelCase to Title Case and remove "Count"
  function camelToTitleCase(camel: string): string {
    const withoutCount = camel.replace("Count", "");
    const words = withoutCount.split(/(?=[A-Z])/);
    const titleCase = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    return titleCase;
  }

  useEffect(() => {
    if (businessType === "brand" && location.pathname === "/analytics/checkins") {
      navigate("/analytics/followers");
    }
    if (analytics && analytics.activeBusinessAnalytics) {
      // Extract and set data for follower and checkin analytics
      const newFollowerData = analytics.activeBusinessAnalytics.favoriteData.userStats;
      const newCheckinData = businessType === "venue" ? analytics.activeBusinessAnalytics.checkinData?.userStats : null;
      const newCheckinHistory = businessType === "venue" ? analytics.activeBusinessAnalytics.checkinHistoryData : null;
      const newFollowerGainData = analytics.activeBusinessAnalytics.followerGainHistoryData;

      setFollowerData(newFollowerData);
      setCheckinData(newCheckinData);
      setCheckinHistory(newCheckinHistory);
      setFollowerGainData(newFollowerGainData);
      setFollowerCount(analytics.activeBusinessAnalytics.favoriteCount.followCount);

      // Format analytics into objects suitable for the charts
      let newFormattedAnalytics = Object.keys(newFollowerData || {}).map((key) => ({
        title: camelToTitleCase(key),
        labels: Object.keys(newFollowerData[key]),
        primaryData: toggleFollowers ? Object.values(newFollowerData[key]) : [],
        secondaryData: toggleCheckins && newCheckinData ? Object.values(newCheckinData[key]) : [],
      }));

      // Update content with the newly formatted analytics
      setContent(
        newFormattedAnalytics.map((analytic: any, index: number) => {
          switch (analytic.title) {
            case "Medical Card":
              return (
                <div style={{ width: "50%" }} key={index}>
                  <AnalyticsVerticalBarChart
                    title={analytic.title}
                    labels={
                      // convert 'other' to 'non-binary'
                      analytic.labels.map((label: string) => (label === "true" ? "Yes" : "No"))
                    }
                    primaryData={
                      dataDisplayType === "followers" || dataDisplayType === "all" ? analytic.primaryData : undefined // Ensure no data is passed if condition is false
                    }
                    secondaryData={
                      dataDisplayType === "non" || dataDisplayType === "all" ? analytic.secondaryData : undefined // Ensure no data is passed if condition is false
                    }
                  />
                </div>
              );
            case "Gender":
              return (
                <div style={{ width: "50%" }} key={index}>
                  <AnalyticsVerticalBarChart
                    title={analytic.title}
                    labels={
                      // convert 'other' to 'non-binary'
                      analytic.labels.map((label: string) => (label === "other" ? "non-binary" : label))
                    }
                    primaryData={
                      dataDisplayType === "followers" || dataDisplayType === "all" ? analytic.primaryData : undefined // Ensure no data is passed if condition is false
                    }
                    secondaryData={
                      dataDisplayType === "non" || dataDisplayType === "all" ? analytic.secondaryData : undefined // Ensure no data is passed if condition is false
                    }
                  />
                </div>
              );
            case "Favorite Applications":
              return null;
            default:
              return (
                <div style={{ width: "50%" }} key={index}>
                  <AnalyticsHorizontalBarChart
                    title={analytic.title}
                    labels={
                      analytic.labels[0] === "true" || analytic.labels[0] === "false" ? ["Yes", "No"] : analytic.labels
                    }
                    primaryData={
                      dataDisplayType === "followers" || dataDisplayType === "all" ? analytic.primaryData : null // Ensure no data is passed if condition is false
                    }
                    secondaryData={
                      dataDisplayType === "non" || dataDisplayType === "all" ? analytic.secondaryData : null // Ensure no data is passed if condition is false
                    }
                  />
                </div>
              );
          }
        }),
      );
    }
  }, [analytics, toggleFollowers, toggleCheckins, businessType, dataDisplayType]);

  return (
    <div>
      {/* HEADER AND ACTIONS */}
      <div className={styles.header}>
        {!toggleCheckins && <h2>Total Followers: {followerCount}</h2>}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 10,
          }}
        >
          {businessType === "venue" && location.pathname === "/analytics/checkins" ? (
            <>
              <button style={{ backgroundColor: "#fff" }} onClick={() => setDataDisplayType("all")}>
                All
              </button>
              <button style={{ backgroundColor: "#0090bc" }} onClick={() => setDataDisplayType("followers")}>
                Followers
              </button>
              <button style={{ backgroundColor: "#90d6e6" }} onClick={() => setDataDisplayType("non")}>
                Non-Followers
              </button>
            </>
          ) : null}
        </div>
      </div>

      {businessType === "venue" ? (
        <AnalyticsHorizontalPinChart
          title={!toggleCheckins ? "New Follower Gain" : "Monthly Visits"}
          labels={!toggleCheckins ? followerGainData?.labels : checkinHistory?.labels}
          primaryData={
            dataDisplayType === "followers" || dataDisplayType === "all" ? followerGainData?.primaryData : undefined // Ensure no data is passed if condition is false
          }
          secondaryData={
            dataDisplayType === "non" || dataDisplayType === "all" ? checkinHistory?.secondaryData : undefined // Ensure no data is passed if condition is false
          }
        />
      ) : (
        <AnalyticsHorizontalPinChart
          title={"New Follower Gain"}
          labels={followerGainData?.labels}
          primaryData={followerGainData?.primaryData}
        />
      )}

      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>{content}</div>

      {/* <div>{formattedAnalytics[4]?.title}</div> */}
      {children ? children : null}
    </div>
  );
};
